import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  roles: [],
  _roles: [],
};
const RoleSlice = createSlice({
  name: 'RoleSlice',
  initialState,
  reducers: {
    addRole: (state, action) => {
      state.roles.push(action.payload);
    },
    _addRole: (state, action) => {
      state._roles.push(action.payload);
    },
    loadRole: (state, action) => {
      state.roles = action.payload;
    },
    _loadRole: (state, action) => {
      state._roles = action.payload;
    },
    updateRoleSuccess: (state, action) => {
      const roleIndex = state.roles.findIndex(
        _role => _role._id == action.payload.id
      );
      state.roles[roleIndex] = { ...action.payload.updatedPrevilliages };
    },
    _updateRoleSuccess: (state, action) => {
      const _roleIndex = state._roles.findIndex(
        _role => _role._id == action.payload._id
      );
      state._roles[_roleIndex] = { ...action.payload };
    },
    roleDeletedSuccess: (state, action) => {
      state.roles = state.roles.filter(_role => _role._id !== action.payload);
    },
    _roleDeletedSuccess: (state, action) => {
      state._roles = state._roles.filter(_role => _role._id !== action.payload);
    },
  },
});
export default RoleSlice.reducer;
export const {
  addRole,
  loadRole,
  updateRoleSuccess,
  _updateRoleSuccess,
  roleDeletedSuccess,
  _addRole,
  _loadRole,
  _roleDeletedSuccess,
} = RoleSlice.actions;
